<template>
    <v-container>
        <v-card class="mx-auto">
            <v-toolbar flat color="secondary">
                <v-toolbar-title>{{edit === true ? 'Edit User':'Tambah Users'}}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                 <v-form
                    ref="form"
                    v-on:submit.prevent="storeUser()"
                    lazy-validation>
                    <v-row>
                        <!-- <v-col cols="6"> -->
                            <v-col cols="12">
                            <v-text-field
                            v-model="name"
                            :counter="50"
                            label="Nama Lengkap"
                            required
                            :rules="this.rules.nama"
                            v-focus
                            ></v-text-field>
                            </v-col>

                            <v-col cols="12">
                            <v-text-field
                            v-model="email"
                            :rules="this.rules.email"
                            label="E-mail"
                            required
                            ></v-text-field>
                            </v-col>

                            <v-col cols="12">
                        <!-- </v-col>

                        <v-col cols="6"> -->
                            <v-text-field
                            :type="show ? 'text' : 'password'"
                            v-model="password"
                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                            @click:append="show = !show"
                            :counter="16"
                            :label="edit ? 'New Password':'Password'"
                            :rules="edit ? this.rules.new_password : this.rules.password"
                            ></v-text-field>
                            </v-col>
                        <!-- </v-col> -->
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-card-actions>
                                <v-btn @click="btnBack"
                                color="grey lighten-5" type="button"><v-icon left>{{icon.back}}</v-icon>Back</v-btn>
                                <v-spacer></v-spacer>
                                <v-btn 
                                :disabled="loading"
                                color="primary" type="submit" class="float-right"><v-icon left>{{icon.save}}</v-icon>Simpan</v-btn>
                            </v-card-actions>
                        </v-col>
                    </v-row>
                 </v-form>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
/* eslint-disable */
    import rules from "@/plugins/validation_rules.js";
    let context;
    export default{
        name:"users.add",
        data:()=>{
            return{
                edit:false,
                loading:false,
                show:false,
                rules:rules,
                icon:{
                    save:"mdi-check-bold",
                    back:"mdi-arrow-left"
                },
                name:"",
                email:"",
                password:""
            }
        },
        methods:{
            btnBack () {
                this.$router.go(-1);
            },
            storeUser:async ()=>{
                if(context.$refs.form.validate()){
                    context.loading=true;
                    let payload={
                        name:context.name,
                        email:context.email,
                        password:context.password
                    };

                    let uri;
                    let success_text;
                    
                    if(!context.edit){
                        await context.$http
                        .post('users/store',payload)
                        .then(response=>{
                            if(response.status===200){
                                context.$notify({
                                    group:"success",
                                    title:"Success Notification",
                                    text:"Berhasil menambahkan "+payload.name+" ke database"
                                })
                                context.$refs.form.reset();
                            }
                        })
                        .catch(err=>{
                            context.$notify({
                                    group:"error",
                                    title:"Error Notification",
                                    text:"Terjadi kesalahan pada client"
                            })
                        });
                    }else{
                        payload.id=context.$route.params.id;
                        await context.$http
                        .patch('users/update',payload)
                        .then(response=>{
                            if(response.status===200){
                                context.$notify({
                                    group:"success",
                                    title:"Success Notification",
                                    text:"Berhasil merubah "+payload.name
                                })
                            }
                        })
                        .catch(err=>{
                            context.$notify({
                                    group:"error",
                                    title:"Error Notification",
                                    text:"Terjadi kesalahan pada client"
                            })
                        });
                    }
                    
                    context.loading=false;
                }
            },

        },
        async mounted(){
            context=this;
            if(context.$route.name==="users.edit"){
                context.edit=true;
                await context.$http
                .get('users/get?id='+context.$route.params.id)
                .then(response=>{
                    let user=response.data.data;
                    if(user!=null){
                        context.name=user.name;
                        context.email=user.email;
                    }else{
                        context.$router.push("/users");
                    }
                })
                .catch(err=>{

                })
            }
        }
    }
</script>